<template>
  <div>
    <p v-if="!mostrado" class="toggle toggle-mas">
      <a class="ver-detalles" @click.prevent="mostrado = !mostrado" href="#"
        >Información del producto</a
      >
    </p>

    <p v-else class="toggle toggle-menos">
      <a class="ver-detalles" @click.prevent="mostrado = !mostrado" href="#"
        >Información del producto</a
      >
    </p>

    <div v-if="mostrado">
      <div>
        <ul class="lista-detalles">
          <li
            v-for="detalle in producto.detallesGarantiaOnline"
            :key="detalle.idSubcobertura"
          >
            <span class="tituloDetalle">{{ detalle.titulo }}.&nbsp;</span>
            <p
              v-for="desc in detalle.descripcion"
              :key="desc"
              class="descripcionDetalle"
            >
              {{ desc }}&nbsp;
            </p>
            <span v-if="detalle.asistenciaViajeOro">
              (más información
              <a
                class="enlaceDocumentoInformativo"
                @click="getDocumentoInformativo('AV_ORO')"
                >Asistencia en Viaje Oro</a
              >)
              <br />
            </span>
            <span v-if="detalle.asistenciaViajePlatino">
              (más información
              <a
                class="enlaceDocumentoInformativo"
                @click="getDocumentoInformativo('AV_ORO')"
                >Asistencia en Viaje Oro</a
              >
              y
              <a
                class="enlaceDocumentoInformativo"
                @click="getDocumentoInformativo('AV_PLATINO')"
                >Asistencia en Viaje Platino</a
              >)
              <br />
            </span>
            <span v-if="detalle.asistenciaViajeMoto">
              (más información
              <a
                class="enlaceDocumentoInformativo"
                @click="getDocumentoInformativo('AV_MOTO')"
                >Asistencia en Viaje Moto</a
              >)
              <br />
            </span>
            <br />
            <br />
          </li>
        </ul>
        <span v-if="producto.conFranquicia" class="notaFranquicia">
          <b>Nota:&nbsp;</b>
          <span
            v-if="
              producto.franquiciaDP &&
                producto.franquiciaINC &&
                producto.franquiciaROBO
            "
            >Franquicia en Daños Propios, Robo e Incendio.</span
          >
          <span
            v-if="
              producto.franquiciaDP &&
                producto.franquiciaINC &&
                !producto.franquiciaROBO
            "
            >Franquicia en Daños Propios e Incendio.</span
          >
          <span
            v-if="
              producto.franquiciaDP &&
                !producto.franquiciaINC &&
                producto.franquiciaROBO
            "
            >Franquicia en Daños Propios y Robo.</span
          >
          <span
            v-if="
              producto.franquiciaDP &&
                !producto.franquiciaINC &&
                !producto.franquiciaROBO
            "
            >Franquicia en Daños Propios.</span
          >
          <span
            v-if="
              !producto.franquiciaDP &&
                producto.franquiciaINC &&
                producto.franquiciaROBO
            "
            >Franquicia en Robo e Incendio.</span
          >

          <span
            v-if="
              !producto.franquiciaDP &&
                producto.franquiciaINC &&
                !producto.franquiciaROBO
            "
            >Franquicia en Incendio.</span
          >

          <span
            v-if="
              !producto.franquiciaDP &&
                !producto.franquiciaINC &&
                producto.franquiciaROBO
            "
            >Franquicia en Robo.</span
          >
          Cantidad que en cada siniestro, según lo pactado en las Condiciones
          Particulares para cada uno de los riesgos cubiertos, asume a su cargo
          el asegurado.
        </span>
      </div>
      <ul class="header-links" style="margin-left: 1rem;">
        <li class="doc">
          <a
            href="https://ww2.mmtseguros.es/sites/default/files/condicionado_general_particulares.pdf"
            >Consulta las condiciones generales de la póliza</a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import actions from "@/util/actions.js";
export default {
  props: {
    producto: {
      type: Object,
      required: true
    },
    mostrarDetallesGarantias: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      mostrado: false
    };
  },

  mounted: function() {
    if (this.mostrarDetallesGarantias) {
      this.mostrado = true;
    }
  },
  methods: {
    getDocumentoInformativo: async function(idDocumento) {
      await actions.getDocumentoInformativo(idDocumento);
    }
  }
};
</script>

<style lang="scss" scoped>
.toggle {
  padding: 0.7rem;
}

.toggle-mas:before {
  display: inline-block;
  vertical-align: top;
  content: "";
  margin-right: 1em;
  width: 2em;
  height: 2em;
  background: url(../assets/sprite_icons.png) no-repeat -160px -40px;
  font-size: 1rem;
}

.toggle-menos:before {
  display: inline-block;
  vertical-align: top;
  content: "";
  margin-right: 1em;
  width: 2em;
  height: 2em;
  background: url(../assets/sprite_icons.png) no-repeat -136px -40px;
  font-size: 1rem;
}

.ver-detalles {
  font-size: 1.8rem;
}

.lista-detalles {
  margin-left: 3rem;
  font-size: 1.8rem;
  // line-height: 50%;
  // @media (max-width: 1023px) {
  //   line-height: 100%;
  // }
  .tituloDetalle {
    font-weight: bolder;
  }
  .descripcionDetalle {
    line-height: normal;
    text-align: justify;
    @media (max-width: 1023px) {
      text-align: left;
    }
  }
}

.notaFranquicia {
  margin-left: 3rem;
  display: block;
  font-size: 1.5rem;
  text-align: justify;
}

.enlaceDocumentoInformativo {
  text-decoration: underline;
  cursor: pointer;
}
</style>
